export const SERVICES = [
  {
    slug: 'web',
    num: '01',
    title: 'בניית אתרים',
    short: 'תכנון, עיצוב ופיתוח.',
    desc: 'תחת קורת גג אחת. ללא שרשרת ספקים.',
  },
  {
    slug: 'landing-pages',
    num: '02',
    title: 'דפי נחיתה',
    short: 'תכלית אחת לכל דף.',
    desc: 'ממוקד לקמפיין או להשקה.',
  },
  {
    slug: 'automations',
    num: '03',
    title: 'אוטומציות',
    short: 'תהליך שחוזר. רץ לבד.',
    desc: 'שעות חוזרות לעסק.',
  },
  {
    slug: 'systems',
    num: '04',
    title: 'מערכות ואוטומציות',
    short: 'כשהמערכות לא מדברות.',
    desc: 'חיבורי מערכות קיימות. בלי להחליף הכל.',
  },
];
